<div class="modal fade hierarchy-modal" id="Operation_Modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-6">
          <span class="modal-title-icon"><i class="fa fa-wrench"></i></span>
          عملیات
        </h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
      </div>
      <div class="modal-body">
        <div class="row g-0 hierarchy-layout">
          <div class="col-md-5 parents-panel">
            <div class="section-title">
              <h6><i class="fa fa-folder text-primary"></i> دسته‌بندی‌ها</h6>
            </div>
            <div class="parent-list">
              <button type="button" class="parent-card active">
                <span class="parent-icon"><i class="fa fa-wrench"></i></span>
                <span class="parent-content"><span class="parent-name">عملیات</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
            </div>
          </div>
          <div class="col-md-7 children-panel">
            <div class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-wrench"></i></span>
              <div><h5>عملیات</h5><p>یکی از موارد زیر را انتخاب کنید.</p></div>
            </div>
            <div class="children-scroll is-scrollable">
              <div class="children-grid">
                <button type="button" class="child-card" [routerLink]="['/repairs/', carId]" *ngIf="acssess?.bRepairs" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-blue"><i class="fa fa-wrench"></i></span>
                  <span class="d-block child-title">تعمیرات و سرویس</span>
                  <span class="child-description">سوابق تعمیرات و سرویس خودرو</span>
                </button>

                <button type="button" class="child-card" [routerLink]="['/services/', carId]" *ngIf="acssess?.bService" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-teal"><i class="fa fa-clipboard"></i></span>
                  <span class="d-block child-title">سرویس های دوره ای</span>
                  <span class="child-description">سرویس‌های دوره‌ای ثبت‌شده</span>
                </button>

                <button type="button" class="child-card" [routerLink]="['/inspection/', carId]" *ngIf="acssess?.bFInspection_User" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-green"><i class="fa fa-shield"></i></span>
                  <span class="d-block child-title">بازرسی ایمنی</span>
                  <span class="child-description">بازرسی‌های ایمنی HSE</span>
                </button>

                <button type="button" class="child-card" [routerLink]="['/periodic-visit/', carId]" *ngIf="acssess?.bPeriodicVisits_User" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-purple"><i class="fa fa-calendar-check-o"></i></span>
                  <span class="d-block child-title">بازدید دوره ای</span>
                  <span class="child-description">بازدیدهای دوره‌ای خودرو</span>
                </button>

                <button type="button" class="child-card" [routerLink]="['/service-part', carId]" *ngIf="acssess?.bServiceParts_User" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-orange"><i class="fa fa-puzzle-piece"></i></span>
                  <span class="d-block child-title">درخواست خدمات و قطعه</span>
                  <span class="child-description">ثبت درخواست خدمات و قطعه</span>
                </button>

                <button type="button" class="child-card" (click)="goToTempAccess()" *ngIf="acssess?.bTemporaryAccess" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-amber"><i class="fa fa-key"></i></span>
                  <span class="d-block child-title">دسترسی های موقت</span>
                  <span class="child-description">مدیریت دسترسی‌های موقت</span>
                </button>

                <button type="button" class="child-card d-none" [routerLink]="['/violations', carId]" data-bs-dismiss="modal" aria-label="Close">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-red"><i class="fa fa-ban"></i></span>
                  <span class="d-block child-title">سوابق خلافی</span>
                  <span class="child-description">سوابق خلافی خودرو</span>
                </button>

                <button type="button" class="child-card" *ngIf="car?.bFuelSensor == 1" (click)="open_Calibration()">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-cyan"><i class="fa fa-tint"></i></span>
                  <span class="d-block child-title">کالیبراسیون باک</span>
                  <span class="child-description">کالیبراسیون سنسور سوخت باک</span>
                </button>

                <button type="button" class="child-card" *ngIf="car?.bTanker == 1" (click)="open_Calibration(true)">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-indigo"><i class="fa fa-truck"></i></span>
                  <span class="d-block child-title">کالیبراسیون تانکر</span>
                  <span class="child-description">کالیبراسیون سنسور تانکر</span>
                </button>

                <button type="button" class="child-card" *ngIf="car?.bWeightSensor == 1" (click)="open_Calibration(false, true)">
                  <span class="child-check"><i class="fa fa-check"></i></span>
                  <span class="child-icon ic-pink"><i class="fa fa-balance-scale"></i></span>
                  <span class="d-block child-title">کالیبراسیون وزن</span>
                  <span class="child-description">کالیبراسیون سنسور وزن</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer hierarchy-footer">
        <button class="btn btn-outline-secondary" data-bs-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>

<!-- Calibration Modal -->
<div class="modal fade" id="calibration_Modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title">کالیبراسیون</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="mb-2">وقتی خودرو روشن و در سطح مسطح قرار دارد اطلاعات زیر را وارد و سپس دکمه ثبت را انتخاب کنید.</p>
        <small><b class="text-danger"> یادداشت : </b>حداقل این عملیات را برای هر وضعیت دوبار تکرار کنید.</small>
        <div class="w-100 row gx-0 gy-0">
          <form [formGroup]="mdl_Calibration" class="col-12 my-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="tiStatus" id="cal_opt_0" [value]="0" formControlName="tiStatus" />
              <label class="form-check-label" for="cal_opt_0">
                {{ weight_Calibration ? "بدون بار" : tanker_Calibration ? "تانکر خالی است" : "باک تقریبا خالی است" }}
              </label>
            </div>
            <div class="form-check mt-2">
              <input class="form-check-input" type="radio" name="tiStatus" id="cal_opt_1" [value]="1" formControlName="tiStatus" />
              <label class="form-check-label" for="cal_opt_1">
                {{ weight_Calibration ? "حداکثر وزن بار" : tanker_Calibration ? "تانکر پر است" : "باک کاملا پر است " }}
              </label>
            </div>
            <div class="form-check mt-2">
              <input class="form-check-input" type="radio" name="tiStatus" id="cal_opt_2" [value]="2" formControlName="tiStatus" />
              <label class="form-check-label" for="cal_opt_2">سایر</label>
            </div>
            <div class="w-100 mt-3">
              <input class="w-100 form-control" oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                [placeholder]="weight_Calibration ? 'وزن بار (کیلوگرم)' : tanker_Calibration ? 'ارتفاع مایع (میلیمتر)' : 'مقدار سوخت موجود در باک (لیتر)'"
                formControlName="iFule" />
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-start">
        <button class="btn btn-success" (click)="submit_Calibration()">&nbsp; ثبت &nbsp;</button>
        <button class="btn btn-outline-secondary" data-bs-dismiss="modal">&nbsp; بستن &nbsp;</button>
      </div>
    </div>
  </div>
</div>